import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { isValidHttpUrl } from '../utils';
var useBeaconScript = function useBeaconScript(appTitle) {
    useEffect(function () {
        var beaconUrl = process.env.REACT_APP_BEACON_ANALYTICS_URL;
        if (!beaconUrl || !isValidHttpUrl(beaconUrl)) {
            console.warn('Analytics tool is not configured.');
            return;
        }
        var title = appTitle || document.title;
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'beaconScript';
        script.async = true;
        script.src = "".concat(beaconUrl, "/beacon.js");
        script.dataset.log = 'false';
        script.dataset.apiRoot = beaconUrl;
        script.dataset.trackers = 'page,click,form';
        script.dataset.identity = 'userAndSession';
        script.dataset.metadata = JSON.stringify({
            appTitle: title
        });
        document.head.appendChild(script);
        return function () {
            script.remove();
            delete globalThis.beacon;
        };
    }, [appTitle]);
    useEffect(function () {
        if (globalThis.beacon) {
            var userObject = JSON.parse(Cookies.get('user') || '{}');
            var nameParts = [];
            if (userObject.userAttributes && typeof userObject.userAttributes.name === 'string') {
                nameParts = userObject.userAttributes.name.split(/, | /);
            }
            globalThis.beacon.identify((userObject === null || userObject === void 0 ? void 0 : userObject.username) || '', {
                first_name: nameParts[1] || '',
                last_name: nameParts[0] || '',
                email: userObject.username || ''
            });
        }
    }, [globalThis.beacon]);
};
export default useBeaconScript;
